import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import i18n from './i18n'
import { createRouter, createWebHistory } from 'vue-router'
// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes: [
        // 定义你的路由
        { path: '/', component: App }
    ]
})

const app = createApp(App);
app.use(router)
app.use(Vant);
app.use(i18n);
app.mount('#app');
